import { createElement } from 'react';
import { FormItem } from '@formily/antd-mobile';
import { createSchemaField, useForm } from '@formily/react';
import { syncUI, useSchema, useScope } from '../';
import { NoticeBar } from 'antd-mobile';
const getComponentName = (componentName) => {
    return componentName.split('.')[0];
};
export const createSchemaComponent = (options) => {
    const { componentName, component } = options;
    const SchemaField = createSchemaField({
        components: {
            [getComponentName(componentName)]: component,
            FormItem,
        },
    });
    const SchemaComponent = (props) => {
        const scope = useScope();
        const form = useForm();
        const schema = useSchema(props);
        schema.mapProperties((s, key) => {
            s['x-component'] = componentName;
            schema.properties[key] = options?.transform?.(s) || s;
        });
        if (!form) {
            return createElement(NoticeBar, { content: "Formily component can only be used in formily form", color: "error", closeable: true });
        }
        return createElement(SchemaField, { schema: schema, scope: scope });
    };
    return syncUI(SchemaComponent);
};
export const createVoidSchemaComponent = (options) => {
    return createSchemaComponent({
        ...options,
        transform(schema) {
            schema.type = 'void';
            schema['x-decorator'] = undefined;
            return options?.transform?.(schema);
        },
    });
};
